/* eslint-disable react-hooks/exhaustive-deps */
import Constant from '../../../common/constant/Constant';
import Utils from '@/common/utils/utils';
import { buildItemTagList } from '@/component/formManagement/addField/handler/MasterKnowledgeHandler';
import { isPermissionAddItemTagOfCreateTicket } from '@/component/formManagement/handler/CommonHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { Box, Checkbox, FormControlLabel, Popper, Radio, RadioGroup, TextField, Tooltip } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { buildAutoFillTagField } from '../handler/TagFieldHandler';
import { queryFieldChild, getFormById } from '@/service/formManagementService';
import SystemField from '@/common/constant/SystemField';
import { cloneDeep } from 'lodash';
import RenderTooltipTitles from './RenderTooltipTitles';
import UnCheckIconWhite from '../../project/settingCategory/UnCheckIconWhite';
import CheckedIcon from '../../project/settingCategory/CheckedIcon';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import _ from "lodash"
import { I18n } from 'aws-amplify';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { isShowFieldEventTypeChatThread, validateShowTagItemEventTypeChatThread, getTagItemsByRelatedSystemFieldValue, validateShowTagItemEventTrigger } from '../../ticketList/handler/KnowledgeTicketHandler';
import { projectListInCorporationAtom } from '@/state/atom/projectAtom';
import PropTypes from 'prop-types';

MenuTagInPutBase.propTypes = {
    API: PropTypes.any,
    isNotAuthen: PropTypes.any,
    listFieldEdited: PropTypes.any,
    setListFieldEdited: PropTypes.any,
    name: PropTypes.any,
    userListOfProject: PropTypes.any,
    detailTicket: PropTypes.any,
    data: PropTypes.any,
    projectDetail: PropTypes.any,
    isProjectManager: PropTypes.any,
    isEdited: PropTypes.bool
};

export default function MenuTagInPutBase(props) {
    const {
        setAIAutoSelectedData,
        aiAutoSelectedData,
        clearErrors,
        detailTicket,
        formsInCorporation,
        fieldsInCorporation
    } = { ...props };
    let resetRelatedField = []
    const [validateError, setValidateError] = useState(props.data?.error);
    const [tagList, setTagList] = useState([]);
    const [tagValue, setTagValue] = useState([]);
    const [enableShowMore, setEnableShowMore] = useState(false);
    const [showAddItemInput, setShowAddItemInput] = useState(false);
    const [numOfRecordDisplay, setNumOfRecordDisplay] = useState(props.data.structure.recordNumber);
    const [firstRender, setFirstRender] = useState(true)
    const [isLoadingInput, setIsLoadingInput] = useState(false)
    const [defaultIndexChecked, setDefaultIndexChecked] = useState(
        !props.data.structure.isAutoFill ||
            props.data.structure.settingSelectItem !==
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
            ? 0
            : ''
    );

    //state using for query tag items paginate.
    const [nextToken, setNextToken] = useState(null);
    //listen scroll event list tag items in tag field and load more items.

    const PopperComponentMemo = useMemo(() => {
        return ({ style, ...props }) => (
            <Popper {...props} style={{ ...style }} className="selectDrop tag-field-multi-select" />
        );
    }, []);

    useEffect(() => {
        const handleScroll = event => {
            const listboxNode = document.querySelector(
                '.tag-field-multi-select .MuiPaper-root .MuiAutocomplete-listbox'
            );
            if (!listboxNode) return;

            if (
                listboxNode &&
                listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight
            ) {
                return queryLoadMoreTagItems();
            }
        };

        document.addEventListener('scroll', handleScroll, true);

        return () => {
            document.removeEventListener('scroll', handleScroll, true);
        };
    }, [tagList, nextToken]);

    const getDefaultChecked = () => {
        let indexOfSelectedTag = null; // don't check default value for radio tag field.
        if (!Utils.isEmptyArray(tagValue) && !tagValue.some(i => i?.value === null)) {
            tagList?.forEach((tag, index) => {
                if (tag?.value === tagValue[0]?.value) {
                    indexOfSelectedTag = index;
                }
            });
        }
        return indexOfSelectedTag;
    };

    const [originItemList, setOriginItemList] = useState([]);
    const [errorsAddItem, setErrorsAddItem] = useState('');

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    //common project atom
    const projectsInCorporation = useRecoilValue(projectListInCorporationAtom)

    // common projectInuse state
    const projectDetail = props?.projectDetail;
    const isProjectManager = props?.isProjectManager;

    let userListOfProject = props?.userListOfProject;

    const [isPermissionAddItemTag, setIsPermissionAddItemTag] = useState(false);
    let argsCommon = {
        API: props?.API,
        isNotAuthen: props?.isNotAuthen,
        tagField: props.data,
        userDetail: userDetail,
        corporationDetail: corporationDetail,
        projectDetail: projectDetail,
        userListOfProject: userListOfProject,
        originItemList: originItemList,
        setOriginItemList: setOriginItemList,
        // listProjectOfUser: listProjectOfUser,
        isPermissionAddItemTag: isPermissionAddItemTag,
        setIsPermissionAddItemTag: setIsPermissionAddItemTag,
        isProjectManager,
        tagList,
        setTagList,
        tagValue,
        setTagValue,
        firstRender,
        defaultValue: Utils.isEmpty(props.defaultValue)
            ? []
            : Utils.convertJSONDataToObject(props.defaultValue),
        setDefaultIndexChecked
    };

    useEffect(() => {
        // check permission add item tag when create ticket
        isPermissionAddItemTagOfCreateTicket(argsCommon);
    }, [props.data]);

    const formatTagList = fieldTagList => {
        let tagItemList = [];
        for (const field of fieldTagList) {
            let fieldStructure = Utils.convertJSONDataToObject(field?.structure);
            const noOfItem = Number(fieldStructure.no);
            const isShowItemInTicket = fieldStructure.isShowItemInTicket ? true : false;
            const hasOwnIsShow = field?.hasOwnProperty('isShow')
            let isShow = true
            if (hasOwnIsShow && field?.isShow === false) {
                isShow = false;
            }

            tagItemList.push({
                title: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name),
                value: field.id,
                no: noOfItem,
                hitNumber: field.hitNumber,
                isShowItemInTicket,
                sysField: field?.sysField,
                isShow
            });
        }

        // sort item list by order
        tagItemList = tagItemList.sort((a, b) => {
            return a.no - b.no;
        });
        return tagItemList;
    };

    const sortItemWithHitNumber = (firstItem, secondItem) => {
        if (firstItem.hitNumber > secondItem.hitNumber) {
            return -1;
        }
        if (firstItem.hitNumber < secondItem.hitNumber) {
            return 1;
        }
        if (firstItem.hitNumber === secondItem.hitNumber) {
            if (Number(firstItem.no) < Number(secondItem.no)) {
                return -1;
            } else {
                return 1;
            }
        }
        return 0;
    };

    useEffect(() => {
        props.register(props.name);
        let tagField = argsCommon.tagField;

        const thisFieldInfo = props?.data
        const SYSTEM_FIELDS_NEED_LISTEN_EFFECT = [
            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.AND,
            Constant.AI_AUTO.SYSTEM_FIELD.OR,
            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE,
            Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER,
        ]
        switch (tagField.structure.settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                buildItemTagList(argsCommon,null,{
                    userDetail: userDetail,
                    projectDetail: projectDetail,
                    corporationDetail: corporationDetail
                });
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
                buildAutoFillTagField(argsCommon);
                break;
            default:
                // HERE
                queryFieldChild(
                    props?.API,
                    props.data.affiliationOrganization,
                    props.data.id,
                    props.data,
                    nextToken,
                    props?.defaultValue
                ).then(result => {
                    setNextToken(result?.nextToken);
                    result = result?.fieldChildList || result
                    
                    // ai auto event field. in here, it's form active ai auto event. we don't need query field child. Because, it doesn't have children.
                    if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE)
                        return result;

                    const systemTagChildList = SystemField.filter(
                        item =>
                            item.usage === Constant.FORM_USAGE.TAG &&
                            item.affiliationField === props.data.id
                    );
                    let tagItemListByFilter = [];
                    if (!Utils.isEmptyArray(result) && Array.isArray(result)) {
                        result.forEach(item => {
                            let structure = Utils.isEmpty(item.structure)
                                ? {}
                                : Utils.convertJSONDataToObject(item.structure);
                            if (structure.isShowItemInTicket || Utils.isEmptyObject(structure)) {
                                tagItemListByFilter.push(item);
                            }
                        });
                    }

                    const tagChildList = !Utils.isEmptyArray(tagItemListByFilter)
                        ? tagItemListByFilter.concat(systemTagChildList)
                        : systemTagChildList;

                    let resFormatTagList = formatTagList(tagChildList);
                    let displayOrder = props.data?.structure?.displayOrder;
                    let tagListSorted = [];

                    /**
                     * filter items by project type. and setting on funcs
                     */
                    let fullAiAutoTicketTypeOptions = resFormatTagList
                    switch (thisFieldInfo?.sysField) {
                        case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:
                            const TICKET_TYPES_FOR_DESK_OFF_PROJECT = [
                                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
                                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE
                            ];
                            

                            const { aiAutoProjectDetail, aiAutoCorporationDetail } = getQueryParamsAIAuto();
                            if (Utils.isPublicOffDeskOff(aiAutoProjectDetail)) {
                                resFormatTagList = _.filter(resFormatTagList, form =>
                                    _.includes(TICKET_TYPES_FOR_DESK_OFF_PROJECT, form?.sysField)
                                );
                            }
                            if (
                                !Utils.isEnableCreateEmailTicketMode(
                                    aiAutoCorporationDetail,
                                    aiAutoProjectDetail
                                )
                            ) {
                                resFormatTagList = _.filter(resFormatTagList, form => {
                                    return (
                                        form?.sysField !==
                                        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL
                                    );
                                });
                            }
                            break;
                        default:
                    }

                    switch (displayOrder) {
                        case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                            tagListSorted = resFormatTagList.sort(sortItemWithHitNumber);
                            break;
                        case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                            tagListSorted = resFormatTagList.sort((a, b) => {
                                let nameA = a.title;
                                let nameB = b.title;
                                return nameA.localeCompare(nameB);
                            });
                            break;
                        case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
                        default:
                            tagListSorted = resFormatTagList.sort((item1, item2) => {
                                return item1.no - item2.no;
                            });
                            break;
                    }
                    setTagList(_.unionBy([...tagListSorted], 'value'));

                    if ([...tagListSorted].length > 0 && props?.setIsTagList) {
                        props?.setIsTagList(true);
                    }

                    // single choice and multiple choice select fields will select a default empty item. <Constant.FIELD_UI_SELECT_DEFAULT_ITEM>
                    if (
                        props.data.structure.optionType ===
                            Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
                    ) {
                        let listOptionItemTagField = [...tagListSorted]

                        if(!props.data.structure.isMultiple){
                            listOptionItemTagField = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM, ...tagListSorted]
                        }
                        setTagList([...listOptionItemTagField]);

                        if(!props.data.structure.isMultiple){
                            setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                        }

                        // ticket detail, display value !? don't sure
                        if (props?.setTagListValue) {
                            props.setTagListValue([resFormatTagList[0]]);
                        }
                    }

                    // default checked first item of list item if single choice
                    // if (
                    //     !props.data.structure.isMultiple &&
                    //     (props.data.structure.settingSelectItem !==
                    //         Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL ||
                    //         !props.data.structure.isAutoFill)
                    // ) {
                    //     setTagValue([resFormatTagList[0]]);
                    //     if (props?.setTagListValue) {
                    //         props.setTagListValue([resFormatTagList[0]]);
                    //     }
                    // }

                    if (props.defaultValue) {
                        const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);

                        if (!Utils.isEmptyArray(defaultValue)) {
                            let listDefaultValue = [];
                            defaultValue.forEach(tagSelected => {
                                if (typeof tagSelected === 'string') {
                                    listDefaultValue.push(tagSelected);
                                } else if (
                                    typeof tagSelected === 'object' &&
                                    !Utils.isEmptyObject(tagSelected)
                                ) {
                                    listDefaultValue.push(tagSelected.value);
                                }
                            });

                            let listDefaultSelectTag = resFormatTagList.filter(tag => {
                                if (listDefaultValue.includes(tag.value)) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });

                            /**
                             * logic for field ticket type of ai auto event form. start
                             */
                            if (
                                thisFieldInfo?.sysField ===
                                Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE
                            ) {
                                let selectedAiAutoTicketTypeValue = _.first(defaultValue);
                                if (_.isString(_.first(defaultValue))) {
                                    selectedAiAutoTicketTypeValue = _.first(defaultValue);
                                } else {
                                    selectedAiAutoTicketTypeValue = _.first(
                                        _.map(defaultValue, ii => ii?.value)
                                    );
                                }
                                if (!_.some(resFormatTagList, i => i?.value === selectedAiAutoTicketTypeValue)) {
                                    const ticketTypeOptionDontShow = _.find(
                                        fullAiAutoTicketTypeOptions,
                                        i => i?.value === selectedAiAutoTicketTypeValue
                                    );

                                    resFormatTagList = resFormatTagList.push({
                                        ...ticketTypeOptionDontShow,
                                        isShow: false
                                    });
                                    setTagValue([{...ticketTypeOptionDontShow, isShow:false}]);
                                    return props.setValue(props?.name, []);
                                }
                            }

                            /**
                             * logic for field ticket type of ai auto event form. start
                             */

                            // listDefaultSelectTag = new Set([...listDefaultSelectTag])
                            listDefaultSelectTag = [...new Map(listDefaultSelectTag.map(item => [item.value, item])).values()];
                   
                            setTagValue([...listDefaultSelectTag]);
                            props.setValue(props?.name, [...listDefaultSelectTag]);
                            if (props.setTagListValue) {
                               props.setTagListValue([...listDefaultSelectTag]);
                            }
                            // return value in here to trans data to next then() in below.
                            return listDefaultSelectTag
                        } else {
                          if(!Utils.isEmptyArray(tagValue))setTagValue([]);
                        }
                    } else {
                       if(!Utils.isEmptyArray(tagValue))setTagValue([]);
                    }
                }).then((resTagList)=>{
                    /**
                     * call get form list options when view ai auto ticket detail by ticket type selected
                     */
                    if (_.includes(SYSTEM_FIELDS_NEED_LISTEN_EFFECT, thisFieldInfo?.sysField)) {
                        console.log('-1')
                        switch (thisFieldInfo?.sysField) {
                            case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:
                                let currentSelectedTicketType = _.find(resTagList, tagItem => {
                                    const thisFieldDefaultValue = Utils.convertJSONDataToObject(
                                        thisFieldInfo?.defaultValue
                                    );

                                    if (_.isString(_.first(thisFieldDefaultValue))) {
                                        return tagItem?.value === _.first(thisFieldDefaultValue);
                                    } else {
                                        return (
                                            tagItem?.value ===
                                            _.first(_.map(thisFieldDefaultValue, ii => ii?.value))
                                        );
                                    }
                                });
                                currentSelectedTicketType = currentSelectedTicketType
                                    ? currentSelectedTicketType
                                    : _.first(resTagList);
                                if (
                                    !Utils.isEmptyObject(currentSelectedTicketType) &&
                                    setAIAutoSelectedData
                                ) {
                                    setAIAutoSelectedData(prev => {
                                        return {
                                            ...prev,
                                            [Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE]: [
                                                currentSelectedTicketType
                                            ]
                                        };
                                    });
                                }
                                const {
                                    aiAutoCorporationQueryId,
                                    aiAutoProjectQueryId,
                                    aiAutoUserQueryId
                                } = getQueryParamsAIAuto();
                                getTagItemsByRelatedSystemFieldValue(
                                    aiAutoCorporationQueryId,
                                    aiAutoProjectQueryId,
                                    aiAutoUserQueryId,
                                    Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
                                    currentSelectedTicketType,
                                    props?.setOptionsOfTagField,
                                    setIsLoadingInput,
                                    firstRender &&
                                    detailTicket &&
                                    detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT,
                                    formsInCorporation,
                                    fieldsInCorporation,
                                    projectsInCorporation
                                );
                                break;
                            case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
                                {
                                    const thisFieldDefaultValue = Utils.convertJSONDataToObject(
                                        thisFieldInfo?.defaultValue
                                    );

                                    if (
                                        !Utils.isEmptyArray(thisFieldDefaultValue) &&
                                        !Utils.isEmptyArray(resTagList) && 
                                        setAIAutoSelectedData
                                    ) {
                                        let selectedEventTrigger = thisFieldDefaultValue
                                            .map(tagItemId =>
                                                resTagList.find(item => item.value === tagItemId)
                                            )
                                            .filter(Boolean);
                                        setAIAutoSelectedData(prev => {
                                            return {
                                                ...prev,
                                                [Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]: [
                                                    ...selectedEventTrigger
                                                ]
                                            };
                                        });
                                    }
                                }

                                break;
                            default:
                        }
                    }
                });
        }
    }, [props.data,props?.triggerReloadTicket]);

    useEffect(() => {
        setValidateError(props.data.error);
    }, [props.data]);

    const getListTicketOfItemList = (itemList, itemIdList) => {
        let ticketIdList = [];
        itemIdList.forEach(id => {
            const itemDetail = itemList.find(item => item.itemId === id);
            if (!Utils.isEmptyObject(itemDetail)) {
                const listTicketIdOfItem = itemDetail.listTicketId;
                listTicketIdOfItem.forEach(ticketId => {
                    if (!ticketIdList.includes(ticketId)) {
                        ticketIdList.push(ticketId);
                    }
                });
            }
        });
        return ticketIdList;
    };

    useEffect(() => {
        //remove default empty item with its value = null
        const validTagValues = tagValue.filter(i => i?.value !== null && i !== null);
        props.setValue(props?.name, [...validTagValues]);
        // if (props?.setIsExChangeTagField) {
        //     props?.setIsExChangeTagField(!props?.isExChangeTagField);
        // }
        /**
         * validate and handle error for fields in ai auto event form. start
         */
        if (
            [
                Constant.AI_AUTO.SYSTEM_FIELD.AND,
                Constant.AI_AUTO.SYSTEM_FIELD.OR,
                Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
            ].includes(props?.data?.sysField)
        ) {
            /**this logic used to logic in "this comment for note 18/12/2024", find by comment
             * fake a item to pass logic validate with tag value. because that logic created validate required field. but in here we need to be enable submit button when don't have any items error into input.
             * */

            const tagValueToEnableEditButton = Utils.isEmptyArray(validTagValues)
                ? [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                : validTagValues;
            props?.setShowButtonEditTicket &&
                props?.setShowButtonEditTicket(tagValueToEnableEditButton);
        }

        if (
            _.some(validTagValues, i => !i?.isShow) &&
            ![
                Constant.AI_AUTO.SYSTEM_FIELD.AND,
                Constant.AI_AUTO.SYSTEM_FIELD.OR,
                Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
            ].includes(props?.data?.sysField)
        ) {
            return setValidateError({
                isError: true,
                message: I18n.get('MSG-CM-TAG-ITEM-UNAVAILABLE')
            });
        }
        /**
         * validate and handle error for fields in ai auto event form. end
         */
        if (!Utils.isEmptyArray(validTagValues)) {
            setValidateError({
                isError: false,
                message: ''
            });
            props.clearErrors(props.name);
        }
        if(firstRender) {
            setValidateError({
                isError: false,
                message: ''
            });
            props.clearErrors(props.name);
        }

        if(
            (!firstRender && props?.isEdited) &&
            props.data.structure.required &&
            Utils.isEmptyArray(validTagValues)
            ) {
            setValidateError({
                isError: true,
                message: 'このフィールドは入力必須です。'
            });

            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
            
        } else {
            if(props.data.structure.required)//if it is field required, we will update to change state submit enable or not
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
            setValidateError(props.data?.error);
        }

    }, [tagValue, firstRender]);

    useEffect(() => {
        const validTagValues = tagValue.filter(i => i?.value !== null && i !== null);
        if(!Utils.isEmptyString(props.submitTime)){
            if(
                props.data.structure.required &&
                Utils.isEmptyArray(validTagValues)
                ) {
                setValidateError({
                    isError: true,
                    message: 'このフィールドは入力必須です。'
                });
    
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
                
            }
        }
    },[props?.submitTime])

    useEffect(async () => {
        const thisFieldInfo = props?.data;
        const SYSTEM_FIELDS_NEED_LISTEN_EFFECT = [
            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.AND,
            Constant.AI_AUTO.SYSTEM_FIELD.OR,
            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE,
            Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER,
            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
        ];

        if (Utils.isEmptyObject(props?.optionsOfTagField)) return true;
        if (!_.includes(SYSTEM_FIELDS_NEED_LISTEN_EFFECT, thisFieldInfo?.sysField)) return true;

        const optionsOfThisField = props?.optionsOfTagField[thisFieldInfo?.sysField];
        await changeTagListByFieldOfThisField(thisFieldInfo?.sysField, optionsOfThisField);
    }, [props?.optionsOfTagField]);

    const changeTagListByFieldOfThisField = async (sysField, optionsOfThisField = []) => {
        /**fake data options using for tag items of ai auto fields */
        const fakeDataOptions = (pureOptionsOfThisField, isDeathOption = false) => {
            return pureOptionsOfThisField.map((pureOptionDetail, idx) => {
                let isShow = pureOptionDetail?.isShow

                if(isDeathOption) isShow = false

                if (props?.fieldListDefaultData) {
                    const aiAutoFormEventField = _.find(
                        props?.fieldListDefaultData,
                        item => item?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE
                    );
                    const valuesForm = props?.getValues()
                    const [formEventFieldValue] = valuesForm[aiAutoFormEventField?.id]
                    if (
                        !formEventFieldValue?.isShow &&
                        _.includes(
                            [
                                Constant.AI_AUTO.SYSTEM_FIELD.AND,
                                Constant.AI_AUTO.SYSTEM_FIELD.OR,
                                Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
                            ],
                            props?.data?.sysField
                        )
                    ) {
                        isShow = false;
                    }
                }

                return {
                    id: pureOptionDetail?.id,
                    name: pureOptionDetail?.name,
                    structure: {
                        no: idx,
                        isShowItemInTicket: true
                    },
                    hitNumber: idx,
                    sysField:sysField,
                    isShow
                };
            });
        };
        
        let formattedTagItems = []
        switch (sysField) {
            case Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE:
                const formatFormOptionsForFormatTagList = fakeDataOptions(optionsOfThisField)
                formattedTagItems = formatTagList(formatFormOptionsForFormatTagList);
                formattedTagItems = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM, ...formattedTagItems]

                /**validate form unshare of prj inuse */
                const defaultValuesClone = Utils.convertJSONDataToObject(props?.defaultValue);
                let defaultOptionsClone = _.filter(formattedTagItems, i => {
                    if (_.isString(_.first(defaultValuesClone))) {
                        return _.includes(defaultValuesClone, i?.value);
                    }
                    return _.includes(
                        _.map(defaultValuesClone, ii => ii?.value),
                        i?.value
                    );
                });

                if(props?.defaultValue && !Utils.isEmptyArray(defaultValuesClone) && Utils.isEmptyArray(defaultOptionsClone) && firstRender) {
                    // if list form only default item. we don't need do anything.
                    if (formattedTagItems.length <= 1) {
                        setTagList([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                        setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                        props.setValue(props?.name, []);
                    } else {
                        const deathForm = await getFormById(null, _.first(defaultValuesClone));
                        const formattedTagItemsHaveDeathForm = _.concat(
                            formattedTagItems,
                            formatTagList(fakeDataOptions([deathForm], true))
                        );
                        // set values display it in FE and set value its to form
                        const defaultOptionsDeath = _.filter(formattedTagItemsHaveDeathForm, i => {
                            if (_.isString(_.first(defaultValuesClone))) {
                                return _.includes(defaultValuesClone, i?.value);
                            }
                            return _.includes(
                                _.map(defaultValuesClone, ii => ii?.value),
                                i?.value
                            );
                        });
                        setTagValue(defaultOptionsDeath);
                        setTagList(formattedTagItems);
                        props.setValue(props?.name, []);

                        setValidateError({
                            isError: true,
                            message: I18n.get('MSG-CM-TAG-ITEM-UNAVAILABLE')
                        });
                    }
                    // const setLoading = props?.setIsLoadingNotRefreshData
                    //     ? props?.setIsLoadingNotRefreshData
                    //     : props?.setIsLoading
                    return setIsLoadingInput(false)
                }
                /**validate form unshare of prj inuse.end */
                //set new tag list and reset selected tag
                const isFormListChanged = _.isEqual(tagList, formattedTagItems)
                if (!isFormListChanged) {
                    /**
                     * reset value when change selected form. start
                     */
                    //set form options list
                    setTagList(formattedTagItems);
                    //reset show error
                    setFirstRender(true);
                    if (props?.defaultValue) {
                        /**fill data for view ticket detail */
                        const defaultValues = Utils.convertJSONDataToObject(props?.defaultValue);
                        /**why coding like this !.
                         * Because data format of props?.defaultValue when we view ticket detail is id.
                         * but when change tab. it is object.
                         * Similar for data of and, or and exclude field.
                        */
                        const defaultOptions = _.filter(formattedTagItems, i => {
                            if (_.isString(_.first(defaultValues))) {
                                return _.includes(defaultValues, i?.value);
                            }
                            return _.includes(
                                _.map(defaultValues, ii => ii?.value),
                                i?.value
                            );
                        });
                        // set values display it in FE and set value its to form
                        setTagValue(defaultOptions);
                        props?.setValue(props?.name, defaultOptions);

                        const {
                            aiAutoCorporationQueryId,
                            aiAutoProjectQueryId,
                            aiAutoUserQueryId
                        } = getQueryParamsAIAuto();
                        return getTagItemsByRelatedSystemFieldValue(
                            aiAutoCorporationQueryId,
                            aiAutoProjectQueryId,
                            aiAutoUserQueryId,
                            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
                            _.first(defaultOptions),
                            props?.setOptionsOfTagField,
                            setIsLoadingInput,
                            (firstRender && props?.detailTicket && props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT),
                            formsInCorporation,
                            fieldsInCorporation,
                            projectsInCorporation
                        );
                    } else {
                        setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                    }
                    setValidateError({
                        isError: false,
                        message: 'このフィールドは入力必須です。'
                    });

                    // Reset 
                    setAIAutoSelectedData(prev => {
                        let newSelectedDataList = [];
                        let currentPrev = {...prev};

                        if (currentPrev?.[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]) {
                            let currentSelectedDataList = currentPrev[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
                            if (!Utils.isEmptyArray(currentSelectedDataList)) {
                                currentSelectedDataList.forEach(eventTriggerItem => {
                                    if (validateShowTagItemEventTrigger(eventTriggerItem, aiAutoSelectedData)) {
                                        newSelectedDataList.push(eventTriggerItem); 
                                    }
                                })
                            }
                        }

                        return {
                            ...prev,
                            [Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]: [...newSelectedDataList]
                        };
                    });

                    /**
                     * reset value when change selected form. end
                     */
                }
                break;
            case Constant.AI_AUTO.SYSTEM_FIELD.AND:
            case Constant.AI_AUTO.SYSTEM_FIELD.OR:
            case Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE:
                const formatOptionsForAndOrExcludeFields = fakeDataOptions(optionsOfThisField)
                formattedTagItems = formatTagList(formatOptionsForAndOrExcludeFields);

                const isOptionsOfFormChanged = _.isEqual(tagList, formattedTagItems)
                /**
                 * reset value when change form. start
                 */
                if (!isOptionsOfFormChanged) {
                    //set values for and, or and exclude selected.
                    let newTagOptions = formattedTagItems
                    // if (firstRender) {
                    //     newTagOptions = [...tagList, ...formattedTagItems];
                    // } else {
                    //     newTagOptions = formattedTagItems;
                    // }
                    setTagList(newTagOptions);

                    if (props?.defaultValue && firstRender) {
                        const defaultValues = Utils.convertJSONDataToObject(props?.defaultValue);
                        const defaultOptions = _.filter(newTagOptions, i => {
                            if (_.isString(_.first(defaultValues))) {
                                return _.includes(defaultValues, i?.value);
                            }
                            return _.includes(
                                _.map(defaultValues, ii => ii?.value),
                                i?.value
                            );
                        });

                        // set values display it in FE and set value its to form
                        const onlyDisplayShowOption = _.filter(defaultOptions, i=> i?.isShow)
                        setTagValue(onlyDisplayShowOption);
                        props?.setValue(props?.name, defaultOptions);
                    } else {
                        setTagValue([]);
                    }
                }
                   /**
                 * reset value when change selected form. start
                 */
                break
            case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
                setTagList(prev => {
                    let itemList = [...prev];
                    itemList = itemList.map(tagItem => {
                        let isShow = validateShowTagItemEventTrigger(tagItem, aiAutoSelectedData);
                        return {...tagItem, isShow}
                    })

                    return itemList;
                })
                break;
            case Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER:
                setTagList(prev => {
                    let itemList = [...prev];
                    itemList = itemList.map(tagItem => {
                        let isShow = validateShowTagItemEventTypeChatThread(tagItem, aiAutoSelectedData);
                        return {...tagItem, isShow}
                    })

                    return itemList;
                })
                break;
            default:
        }
    };

    const compareListItem = (firstArray, secondArray) => {
        if (firstArray.length !== secondArray.length) {
            return false;
        }
        firstArray.forEach(itemOfFirstArray => {
            const findResult = secondArray.find(itemOfSecondArray => {
                return itemOfFirstArray.value === itemOfSecondArray.value;
            });
            if (Utils.isEmptyObject(findResult)) {
                return false;
            }
        });
        return true;
    };

    const isAutoFill = () => {
        return (
            props.data.structure.isAutoFill &&
            props.data.structure.settingSelectItem ===
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
        );
    };

    const resetItemList = (selectedTicketIdOfMasterForm, orderOfSelectedFields) => {
        let newItemIdList = [];
        let newItemList = [];
        let listItem = props.data.structure.listItem;
        orderOfSelectedFields.forEach((fieldId, index) => {
            // filter theo các field đã được chọn trước đó
            const selectedTicketIdListOfField = selectedTicketIdOfMasterForm[`${fieldId}`];
            const listItemTmp = cloneDeep(listItem);
            if (!Utils.isEmptyArray(selectedTicketIdListOfField)) {
                listItem = listItemTmp.filter(item => {
                    return isExistSameItem(item.listTicketId, selectedTicketIdListOfField);
                });
            }
        });
        listItem.forEach(item => newItemIdList.push(item.itemId));
        newItemList = originItemList.filter(item => newItemIdList.includes(item.value));
        setTagList([...newItemList]);
        if (newItemList.length === 1) {
            setTagValue([...newItemList]);
        }
    };

    const filterFieldAutoFill = (
        selectedTicketIdOfMasterForm,
        orderOfSelectedFields,
        autoFillObjectClone,
        indexOfField
    ) => {
        let newItemIdList = [];
        let newItemList = [];
        let listItem = props.data.structure.listItem;
        const currentTagValue = cloneDeep(tagValue);
        orderOfSelectedFields.forEach((fieldId, index) => {
            // filter theo các field đã được chọn trước đó
            if (indexOfField === -1 || index < indexOfField) {
                const selectedTicketIdListOfField = selectedTicketIdOfMasterForm[`${fieldId}`];
                const listItemTmp = cloneDeep(listItem);
                if (!Utils.isEmptyArray(selectedTicketIdListOfField)) {
                    listItem = listItemTmp.filter(item => {
                        return isExistSameItem(item.listTicketId, selectedTicketIdListOfField);
                    });
                }
            }
        });
        listItem.forEach(item => newItemIdList.push(item.itemId));
        newItemList = originItemList.filter(item => newItemIdList.includes(item.value));
        setTagList([...newItemList]);
        let newTagValue = [];
        if (currentTagValue.length !== 0) {
            newTagValue = currentTagValue.filter(item => newItemIdList.includes(item.value));
        }
        if (newItemList.length === 1) {
            setTagValue([...newItemList]);
        } else {
            if (orderOfSelectedFields.includes(props.name)) {
                setTagValue([...newTagValue]);
            } else {
                setTagValue([]);
            }
        }
        //khi có item của của field đã được chọn bị xóa khỏi list item sau filter
        if (
            orderOfSelectedFields.includes(props.name) &&
            !compareListItem(newTagValue, currentTagValue)
        ) {
            let listItemOfField = props.data.structure.listItem;
            let selectedItemIdList = [];
            newTagValue.forEach(item => selectedItemIdList.push(item?.value));
            selectedTicketIdOfMasterForm[`${props.name}`] =
                newTagValue.length === 0
                    ? []
                    : getListTicketOfItemList(listItemOfField, selectedItemIdList);
            autoFillObjectClone.orderOfSelectedFields =
                newTagValue.length === 0
                    ? orderOfSelectedFields.filter(id => id !== props.name)
                    : orderOfSelectedFields;
            autoFillObjectClone.selectedTicketIdOfMasterForm = selectedTicketIdOfMasterForm;
            props.setAutoFillObject({ ...autoFillObjectClone });
        }

        return;
    };

    useEffect(() => {
        try {
            if (
                props.data.structure.isAutoFill &&
                props.data.structure.settingSelectItem ===
                    Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
            ) {
                let autoFillObjectClone = cloneDeep(props.autoFillObject);
                let orderOfSelectedFields = Utils.isEmptyArray(
                    autoFillObjectClone.orderOfSelectedFields
                )
                    ? []
                    : autoFillObjectClone.orderOfSelectedFields;
                let currentFieldChangeInfo = Utils.isEmptyArray(
                    autoFillObjectClone.currentFieldChangeInfo
                )
                    ? []
                    : autoFillObjectClone.currentFieldChangeInfo;
                let selectedTicketIdOfMasterForm = Utils.isEmptyArray(
                    autoFillObjectClone.selectedTicketIdOfMasterForm
                )
                    ? {}
                    : autoFillObjectClone.selectedTicketIdOfMasterForm;
                const indexOfField = orderOfSelectedFields.findIndex(id => id == props.name);
                // Không filter item được click
                if (
                    !Utils.isEmptyObject(autoFillObjectClone) &&
                    props.name !== currentFieldChangeInfo?.fieldId
                ) {
                    if (!orderOfSelectedFields.includes(props.name)) {
                        // filter các field chưa được click
                        filterFieldAutoFill(
                            selectedTicketIdOfMasterForm,
                            orderOfSelectedFields,
                            autoFillObjectClone,
                            indexOfField
                        );
                    } else {
                        // filter các item được click sau item được click
                        if (
                            indexOfField >= currentFieldChangeInfo.index &&
                            currentFieldChangeInfo.typeOfChange === 'changeItem'
                        ) {
                            filterFieldAutoFill(
                                selectedTicketIdOfMasterForm,
                                orderOfSelectedFields,
                                autoFillObjectClone,
                                indexOfField
                            );
                        }
                    }
                }
            }
        } catch (error) {
            
        }
    }, [props.autoFillObject, originItemList]);


    const onChangeCheckBoxHandler = e => {
        setFirstRender(false)
        let newTagValue;
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
        }
        if (e.target.checked) {
            const checkedItem = tagList.find(item => item.value === e.target.value);
            newTagValue = cloneDeep([...tagValue, checkedItem]);
            setTagValue([...tagValue, checkedItem]);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(newTagValue);
            return newTagValue;
        } else {
            newTagValue = tagValue.filter(item => item.value !== e.target.value);
            setTagValue([...newTagValue]);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(tagValue);
            return newTagValue;
        }
    };

    const onChangeRadioButtonHandler = e => {
        setFirstRender(false)
        const index = tagList.findIndex(tag => tag.value === e.target.value);

        if (
            props.data.structure.isAutoFill &&
            props.data.structure.settingSelectItem ===
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
        ) {
            if (tagValue[0]) {
                if (e.target.value === tagValue[0].value) {
                    setTagValue([]);
                    setDefaultIndexChecked(index);
                    return [];
                }
            }
        }
        const newTagValue = cloneDeep([tagList[index]]);

        if(!isDisableField())
            setTagValue([tagList[index]]);
        

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }

            //using for unchecked radio button
            if ((tagValue[0]?.value === e.target.value || !e.target.value) && !isDisableField())
                return setTagValue([{ value: null }]);
            
        }
        setDefaultIndexChecked(index);
        return newTagValue;
    };

    const  isDisableField = () => {
        if( props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false ) return true
        return false
     }

    const handleOnKeyPressAddItem = e => {
        if (Utils.isEmptyString(e.target.value.trim())) {
            if (e.key === 'Enter') {
                setErrorsAddItem('選択項目を入力してください。');
            }
            return;
        }
        if (e.key === 'Enter') {
            const newItem = {
                title: e.target.value,
                value: `${new Date().getTime()}`,
                isNewItem: true,
                no: tagList.length + 1
            };
            let tagListTemp = tagList;
            if (
                enableShowMore ||
                props.data.structure.optionType === Constant.TAG_FIELD_OPTION_TYPE.SELECT
            ) {
                tagListTemp.push(newItem);

                if (props.data.structure.isMultiple) {
                    setTagValue([...tagValue, newItem]);
                } else {
                    setDefaultIndexChecked(tagListTemp.length);
                    setTagValue([newItem]);
                }
            } else {
                const tagListLength = tagList.length;
                let indexOfNewItem = numOfRecordDisplay;
                if (tagListLength <= numOfRecordDisplay) {
                    indexOfNewItem = tagListLength;
                }
                tagListTemp.splice(indexOfNewItem, 0, newItem);
                if (props.data.structure.isMultiple) {
                    setTagValue([...tagValue, newItem]);
                } else {
                    setDefaultIndexChecked(indexOfNewItem);
                    setTagValue([newItem]);
                }
                setNumOfRecordDisplay(Number(numOfRecordDisplay) + 1);
            }
            if (props?.setIsEdited) {
                if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
                props?.setIsEdited(true);
                if(!props?.listFieldEdited?.includes(props?.name)){
                    props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                }
            }
            setTagList([...tagListTemp]);
            setShowAddItemInput(false);
        } else {
            return;
        }
    };

    const enableShowMoreTagList = () => {
        setEnableShowMore(true);
        if (
            props.data.structure.optionType === Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE
        ) {
            if (!props.data.structure.isMultiple) {
                let listOptionItemTagField = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM, ...tagList];
                setTagList([...listOptionItemTagField]);
                if (Utils.isEmptyArray(tagValue)) {
                    setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                }
            }
        }
        return queryLoadMoreTagItems()
    };

    const queryLoadMoreTagItems = async () => {
        if (Utils.isEmptyObject(nextToken)) return;

        const result = await queryFieldChild(
            props?.API,
            props.data.affiliationOrganization,
            props.data.id,
            props.data,
            nextToken
        );
        const newTagFieldItems = result?.fieldChildList || result;
        if (newTagFieldItems?.length > 0) {
            addMoreAndSortTagItems(newTagFieldItems);
        }
        if (!result?.nextToken) return setNextToken({});
        setNextToken(result?.nextToken);
    };

    const addMoreAndSortTagItems = (newTagItems = [], fieldInfo = props?.data) => {
        let tagItemListByFilter = [];
        const systemTagChildList = SystemField.filter(
            item =>
                item.usage === Constant.FORM_USAGE.TAG && item.affiliationField === props.data.id
        );

        if (!Utils.isEmptyArray(newTagItems)) {
            newTagItems.forEach(item => {
                let structure = Utils.isEmpty(item.structure)
                    ? {}
                    : Utils.convertJSONDataToObject(item.structure);
                if (structure.isShowItemInTicket || Utils.isEmptyObject(structure)) {
                    tagItemListByFilter.push(item);
                }
            });
        }

        const tagChildList = !Utils.isEmptyArray(tagItemListByFilter)
            ? tagItemListByFilter.concat(systemTagChildList)
            : systemTagChildList;

        let resFormatTagList = [...tagList, ...formatTagList(tagChildList)];
        let displayOrder = props.data?.structure?.displayOrder;

        // ensure unique items.
        const seen = new Set();
        const uniqueData = resFormatTagList.filter(obj => {
            if (seen.has(obj.id)) return false;
            seen.add(obj.id);
            return true;
          });
        let tagListSorted = uniqueData

        /**
         * filter items by project type. and setting on funcs
         */
        let fullAiAutoTicketTypeOptions = resFormatTagList;

        switch (fieldInfo?.sysField) {
            case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:
                const TICKET_TYPES_FOR_DESK_OFF_PROJECT = [
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE
                ];

                const { aiAutoProjectDetail, aiAutoCorporationDetail } = getQueryParamsAIAuto();
                if (Utils.isPublicOffDeskOff(aiAutoProjectDetail)) {
                    resFormatTagList = _.filter(resFormatTagList, form =>
                        _.includes(TICKET_TYPES_FOR_DESK_OFF_PROJECT, form?.sysField)
                    );
                }
                if (
                    !Utils.isEnableCreateEmailTicketMode(
                        aiAutoCorporationDetail,
                        aiAutoProjectDetail
                    )
                ) {
                    resFormatTagList = _.filter(resFormatTagList, form => {
                        return form?.sysField !== Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL;
                    });
                }
                break;
            default:
        }

        switch (displayOrder) {
            case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                tagListSorted = resFormatTagList.sort(sortItemWithHitNumber);
                break;
            case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                tagListSorted = resFormatTagList.sort((a, b) => {
                    let nameA = a.title;
                    let nameB = b.title;
                    return nameA.localeCompare(nameB);
                });
                break;
            case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
            default:
                tagListSorted = resFormatTagList.sort((item1, item2) => {
                    return item1.no - item2.no;
                });
                break;
        }
        setTagList(_.unionBy([...tagListSorted], 'value'));

        if ([...tagListSorted].length > 0 && props?.setIsTagList) {
            props?.setIsTagList(true);
        }

        // single choice and multiple choice select fields will select a default empty item. <Constant.FIELD_UI_SELECT_DEFAULT_ITEM>
        if (
            props.data.structure.optionType ===
                Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
        ) {
            let listOptionItemTagField = [...tagListSorted]

            if(!props.data.structure.isMultiple){
                listOptionItemTagField = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM, ...tagListSorted]
            }
            setTagList(_.unionBy([...listOptionItemTagField], 'value'));

            if(!props.data.structure.isMultiple){
         //       setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
            }

            // ticket detail, display value !? don't sure
            if (props?.setTagListValue) {
             //   props.setTagListValue([resFormatTagList[0]]);
            }
        }

        /**check render selected tag item in ticket detail */
        // const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);
        // if (!Utils.isEmptyArray(tagValue)) setTagValue([]);
        // if (defaultValue) {
        //     if (!Utils.isEmptyArray(defaultValue)) {
        //         let listDefaultValue = [];
        //         defaultValue.forEach(tagSelected => {
        //             if (typeof tagSelected === 'string') {
        //                 listDefaultValue.push(tagSelected);
        //             } else if (
        //                 typeof tagSelected === 'object' &&
        //                 !Utils.isEmptyObject(tagSelected)
        //             ) {
        //                 listDefaultValue.push(tagSelected.value);
        //             }
        //         });

        //         let listDefaultSelectTag = resFormatTagList.filter(tag => {
        //             if (listDefaultValue.includes(tag.value)) {
        //                 return true;
        //             } else {
        //                 return false;
        //             }
        //         });

        //         /**
        //          * logic for field ticket type of ai auto event form. start
        //          */
        //         if (fieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE) {
        //             let selectedAiAutoTicketTypeValue = _.first(defaultValue);
        //             if (_.isString(_.first(defaultValue))) {
        //                 selectedAiAutoTicketTypeValue = _.first(defaultValue);
        //             } else {
        //                 selectedAiAutoTicketTypeValue = _.first(
        //                     _.map(defaultValue, ii => ii?.value)
        //                 );
        //             }
        //             if (
        //                 !_.some(resFormatTagList, i => i?.value === selectedAiAutoTicketTypeValue)
        //             ) {
        //                 const ticketTypeOptionDontShow = _.find(
        //                     fullAiAutoTicketTypeOptions,
        //                     i => i?.value === selectedAiAutoTicketTypeValue
        //                 );

        //                 resFormatTagList = resFormatTagList.push({
        //                     ...ticketTypeOptionDontShow,
        //                     isShow: false
        //                 });
        //        //         setTagValue([{ ...ticketTypeOptionDontShow, isShow: false }]);
        //       //          return props.setValue(props?.name, []);
        //             }
        //         }

        //         /**
        //          * logic for field ticket type of ai auto event form. start
        //          */

        //       //  setTagValue([...listDefaultSelectTag]);
        //      //   props.setValue(props?.name, [...listDefaultSelectTag]);
        //         if (props.setTagListValue) {
        //       //      props.setTagListValue([...listDefaultSelectTag]);
        //         }
        //         // return value in here to trans data to next then() in below.
        //         return listDefaultSelectTag;
        //     }
        // }
    };

    const isCheckedItem = itemValue => {
        const foundItem = tagValue.find(element => element.value === itemValue);
        if (!Utils.isEmptyObject(foundItem)) {
            return true;
        } else {
            return false;
        }
    };

    const onChangeAddItem = e => {
        setFirstRender(false)
        if (Utils.isEmptyString(e.target.value)) {
            setErrorsAddItem('選択項目を入力してください。');
        } else {
            setErrorsAddItem('');
        }
    };

    const isExistSameItem = (firstItemList, secondItemList) => {
        if (!Utils.isEmptyArray(firstItemList) && !Utils.isEmptyArray(secondItemList)) {
            const sameItemList = firstItemList.filter(item => {
                return secondItemList.includes(item);
            });
            return !Utils.isEmptyArray(sameItemList);
        }
        return false;
    };

    const checkContainsArray = (firstElementsList, secondElementsList) => {
        const lengthOfFistList = firstElementsList.length;
        for (let i = 0; i < lengthOfFistList; i++) {
            let indexOfElement = secondElementsList.findIndex(
                item => item.value === firstElementsList[i].value
            );
            if (indexOfElement === -1) {
                return false;
            }
        }
        return true;
    };

    const onClickHandler = eventObj => {
        const SYSTEM_FIELDS_HAVE_DEPENDENT_QUERY = [
            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
        ];
        setFirstRender(false)
        let currentTagValue = cloneDeep(tagValue);
        let newTagValue = [];
        switch (eventObj.type) {
            case 'checkBox':
                newTagValue = onChangeCheckBoxHandler(eventObj.value);
                break;
            case 'radio':
                newTagValue = onChangeRadioButtonHandler(eventObj.value);
                break;
            case 'select':
                let selectedItems = eventObj.value;
                const userAddedDefaultEmptyItem = _.last(selectedItems)?.value === null;
                const existedDefaultEmptyItem = _.head(selectedItems)?.value === null;

                // clear default empty item when user pick a item
                if (existedDefaultEmptyItem && _.size(selectedItems) > 1)
                    selectedItems = _.filter(selectedItems, i => i?.value !== null);

                //if default empty item added to tag value. we will clear other items in list
                if (userAddedDefaultEmptyItem && _.size(selectedItems) > 1)
                    selectedItems = _.filter(selectedItems, i => i?.value === null);
                setTagValue(selectedItems);

                const sysFieldOfThisField = props?.data?.sysField

                if ([Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER, Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE].includes(sysFieldOfThisField) && setAIAutoSelectedData) {
                    setAIAutoSelectedData(prev => {
                        let currentData = { ...prev || {} };
                        if (
                            sysFieldOfThisField ===
                                Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE &&
                            currentData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER] &&
                            !Utils.isEmptyArray(currentData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER])
                        ) {
                            let currentSelectedItem =
                                currentData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
                            let newAiAutoSelectedData = {
                                ...aiAutoSelectedData
                            };
                            newAiAutoSelectedData[
                                Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE
                            ] = selectedItems;

                            let newEventTriggerValue = [];
                            if (!Utils.isEmptyArray(currentSelectedItem)) {
                                let newSelectedItemList = currentSelectedItem.map(tagItem => {
                                    if (
                                        validateShowTagItemEventTrigger(tagItem, newAiAutoSelectedData)
                                    )
                                        return tagItem;
                                    return null;
                                });
                                newSelectedItemList = newSelectedItemList.filter(item => item);
                                newEventTriggerValue = newSelectedItemList;
                            }

                            currentData[
                                Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
                            ] = newEventTriggerValue;
                        }

                        return {
                            ...currentData,
                            [sysFieldOfThisField]: selectedItems
                        };
                    });
                }

                if (SYSTEM_FIELDS_HAVE_DEPENDENT_QUERY.includes(sysFieldOfThisField)) {
                    const {
                        aiAutoCorporationQueryId,
                        aiAutoProjectQueryId,
                        aiAutoUserQueryId
                    } = getQueryParamsAIAuto();
                    getTagItemsByRelatedSystemFieldValue(
                        aiAutoCorporationQueryId,
                        aiAutoProjectQueryId,
                        aiAutoUserQueryId,
                        sysFieldOfThisField,
                        _.first(selectedItems),
                        props?.setOptionsOfTagField,
                        setIsLoadingInput,
                        (firstRender && props?.detailTicket && props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT),
                        formsInCorporation,
                        fieldsInCorporation,
                        projectsInCorporation
                    );

                    /**
                     * ai auto reset value when change parent fields.
                     */
                    const PARENT_FIELDS = [Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE ]
                    if (
                       _.includes(PARENT_FIELDS, sysFieldOfThisField)
                    ) {
                        let fieldListData = props?.fieldListDefaultData;
                        let fieldsNeedReset =[
                            Constant.AI_AUTO.SYSTEM_FIELD.AND,
                            Constant.AI_AUTO.SYSTEM_FIELD.OR,
                            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
                        ]

                        if (props?.isDraftMode && props?.isTicketKnowledge && !Utils.isEmptyArray(props?.fieldListData)) {
                            fieldListData = props?.fieldListData;
                        }

                        if(sysFieldOfThisField === Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE) fieldsNeedReset.push(Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE)
                        
                            fieldListData = _.map(fieldListData, fieldData => {
                            if (_.includes(fieldsNeedReset, fieldData?.sysField)) {
                                if (
                                    fieldData?.sysField ===
                                    Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE
                                ) {
                                    if (props?.isDraftMode && props?.isTicketKnowledge && props.setCurrentPanelInitData && sysFieldOfThisField === Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE) {
                                        let listFieldToResetData = [];

                                        fieldListData.map(fieldDataReset => {
                                            if (fieldsNeedReset.includes(fieldDataReset?.sysField)) {
                                                listFieldToResetData.push(fieldDataReset.id);
                                            }
                                        })

                                        props.setCurrentPanelInitData(prev => {
                                            if (!Utils.isEmptyArray(listFieldToResetData)) {
                                                listFieldToResetData.map(fieldResetId => {
                                                    if (prev?.formData && prev?.formData.hasOwnProperty(fieldResetId)) {
                                                        prev['formData'][fieldResetId] = JSON.stringify(
                                                            [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                                                        )
                                                    }
                                                })
                                            }

                                            if (prev?.formData && prev?.formData.hasOwnProperty(fieldData?.id)) {
                                                prev['formData'][fieldData?.id] = JSON.stringify(
                                                    [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                                                )
                                            }
                     
                                            return prev;
                                        })
                                    }
                                    return {
                                        ...fieldData,
                                        defaultValue: JSON.stringify(
                                           [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                                        )
                                    };
                                }

                                return {
                                    ...fieldData,
                                    defaultValue: JSON.stringify([])
                                };
                            }
                            return fieldData;
                        });

                        const andOrExcludeFieldIds = _.map(props?.fieldListDefaultData, field => {
                            if (_.includes(fieldsNeedReset, field?.sysField)) return field?.id;
                            return null;
                        }).filter(i => i);
                        
                        // set edit field list.
                        if (andOrExcludeFieldIds.length > 0) {
                            resetRelatedField = andOrExcludeFieldIds;
                        }

                        if (props?.setFieldListDefaultData)
                            props?.setFieldListDefaultData(fieldListData);
                    }
                }
                newTagValue = selectedItems;
                queryLoadMoreTagItems();
                break;
            default:
                break;
        }
        if (
            props.data.structure.isAutoFill &&
            props.data.structure.settingSelectItem ===
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
        ) {
            let listItemOfField = props.data.structure.listItem;
            //{orderOfSelectedFields: [],selectedTicketIdOfMasterForm: {},currentFieldChangeInfo:{fieldId:id, index: index, typeOfChange: ''}}
            let autoFillObjectClone = cloneDeep(props.autoFillObject);
            let orderOfSelectedFields = Utils.isEmptyArray(
                autoFillObjectClone.orderOfSelectedFields
            )
                ? []
                : autoFillObjectClone.orderOfSelectedFields;
            let selectedTicketIdOfMasterForm = Utils.isEmptyArray(
                autoFillObjectClone.selectedTicketIdOfMasterForm
            )
                ? {}
                : autoFillObjectClone.selectedTicketIdOfMasterForm;
            let currentFieldChangeInfo = {};
            currentFieldChangeInfo.fieldId = props.name;
            //Bỏ chọn giá trị tự động input
            if (
                (Utils.isEmptyArray(newTagValue) || newTagValue[0] === null) &&
                !orderOfSelectedFields.includes(props.name)
            ) {
                return;
            }
            //Bỏ toàn bộ Item
            if (newTagValue.length === 0) {
                currentFieldChangeInfo.typeOfChange = 'changeItem';
                currentFieldChangeInfo.index = orderOfSelectedFields.findIndex(
                    id => id == props.name
                );
                selectedTicketIdOfMasterForm[`${props.name}`] = [];
                autoFillObjectClone.currentFieldChangeInfo = currentFieldChangeInfo;
                autoFillObjectClone.orderOfSelectedFields = orderOfSelectedFields.filter(
                    id => id != props.name
                );
                autoFillObjectClone.selectedTicketIdOfMasterForm = selectedTicketIdOfMasterForm;
                props.setAutoFillObject({ ...autoFillObjectClone });
                resetItemList(
                    selectedTicketIdOfMasterForm,
                    autoFillObjectClone.orderOfSelectedFields
                );
                return;
            }
            let selectedItemIdList = [];
            newTagValue.forEach(item => selectedItemIdList.push(item.value));
            selectedTicketIdOfMasterForm[`${props.name}`] = getListTicketOfItemList(
                listItemOfField,
                selectedItemIdList
            );
            let indexOfFiledInSelectedOrder;
            if (orderOfSelectedFields.includes(props.name)) {
                indexOfFiledInSelectedOrder = orderOfSelectedFields.findIndex(
                    id => id == props.name
                );
            } else {
                indexOfFiledInSelectedOrder = orderOfSelectedFields.push(props.name);
            }
            currentFieldChangeInfo.index = indexOfFiledInSelectedOrder;
            currentFieldChangeInfo.typeOfChange = checkContainsArray(currentTagValue, newTagValue)
                ? 'addItem'
                : 'changeItem';
            autoFillObjectClone.currentFieldChangeInfo = currentFieldChangeInfo;
            autoFillObjectClone.orderOfSelectedFields = orderOfSelectedFields;
            autoFillObjectClone.selectedTicketIdOfMasterForm = selectedTicketIdOfMasterForm;
            props.setAutoFillObject({ ...autoFillObjectClone });
            return;
        }
    };

    const getError = (errorList, name) => {
        if(Utils.isEmptyArray(errorList)) {
            return '';
        }

        if(!errorList[name]) {
            return '';
        }

        if (
            { ...props }?.data?.sysField ===
                Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER &&
            !isShowFieldEventTypeChatThread(aiAutoSelectedData)
        ) {
            return '';
        }

        return errorList[name].message;
    }

    const filterSuggestionInputChip = createFilterOptions({
        matchFrom: 'any',
        stringify: option => `${option?.title}`
    });

    const getQueryParamsAIAuto = () =>{
        let aiAutoCorporationQueryId = corporationDetail?.id
        let aiAutoProjectQueryId = projectDetail?.id
        let aiAutoUserQueryId = userDetail?.id
        let aiAutoProjectDetail = projectDetail
        let aiAutoCorporationDetail = corporationDetail

        if (props?.detailTicket && props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT) {
            if (!Utils.isEmptyString(props?.detailTicket?.affiliationOrganization))
                aiAutoCorporationQueryId = props?.detailTicket?.affiliationOrganization;
            if (!Utils.isEmptyString(props?.detailTicket?.affiliationProject))
                aiAutoProjectQueryId = props?.detailTicket?.affiliationProject;
            if (!Utils.isEmptyString(props?.detailTicket?.creator))
                aiAutoUserQueryId = props?.detailTicket?.creator;
            if (!Utils.isEmptyObject(props?.ticketAffiliationProject))
                aiAutoProjectDetail = props?.ticketAffiliationProject;
            if (!Utils.isEmptyObject(props?.corporationAffiliationTicket))
                aiAutoCorporationDetail = props?.corporationAffiliationTicket;
        }

        return {
            aiAutoCorporationQueryId,
            aiAutoProjectQueryId,
            aiAutoUserQueryId,
            aiAutoProjectDetail,
            aiAutoCorporationDetail
        }
    }

    // Eff update value of tag field related
    useEffect(() => {
        if (!Utils.isEmptyObject(aiAutoSelectedData)) {
            if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER) {
                if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) {
                    if (firstRender) {
                        setTagValue(prev => {
                            let itemList = [...prev];
                            itemList = itemList.map(tagItem => {
                                return {...tagItem, isShow: false}
                            })
                            return itemList;
                        });
                    } else {
                        setTagValue([]);
                    }
                    setValidateError({
                        isError: false,
                        message: ''
                    });
                    clearErrors({...props}?.name);
                    setFirstRender(true);
                    return;
                }

                let isUpdateTriggerField = false;
                setTagValue(prev => {
                    let itemList = [...prev];
                    itemList = itemList.map(tagItem => {
                        let isShow = validateShowTagItemEventTypeChatThread(tagItem, aiAutoSelectedData);
                        return {...tagItem, isShow}
                    })
                    itemList = itemList.filter(item => item.isShow);
                    if (prev?.length !== itemList?.length) {
                        isUpdateTriggerField = true;
                    }

                    return itemList;
                });

                if (isUpdateTriggerField) {
                    if (!props?.listFieldEdited?.includes(props?.name) && props?.setListFieldEdited) {
                        props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
                    }
                }
            }

            if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER) {
                // Skip trigger when not init done 
                // Fix for https://new.redmine.ominext.com/issues/214042 case 1
                if (
                    aiAutoSelectedData.hasOwnProperty(
                        Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
                    ) &&
                    !aiAutoSelectedData.hasOwnProperty(
                        Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE
                    )
                ) {
                    return;
                }

                setTagValue(prev => {
                    let currentSelectedItem = [...prev];
                    if (!Utils.isEmptyArray(currentSelectedItem)) {
                        let newSelectedItemList = currentSelectedItem.map(tagItem => {
                            if (validateShowTagItemEventTrigger(tagItem, aiAutoSelectedData)) return tagItem;
                            return null;
                        })
                        newSelectedItemList = newSelectedItemList.filter(item => item);
                        return newSelectedItemList;
                    }
                    return [];
                });
            }
        }
    },[aiAutoSelectedData, firstRender])

    // Show/hide field_event_type_chat_thread field
    if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER) {
        if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) {
            return null;
        } 
    }

    return (
        <>
            <div className="form-addTicket">
                <div className="cell-prod-status gap-8">
                    {props?.isTooltipTitle ? 
                        <RenderTooltipTitles {...props}/> :
                        <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                    }
                    {props?.isShowIconCopyFieldId && (
                        <Tooltip title={props?.data.id} placement='top' arrow>
                            <img
                                src="/assets/image/icon-copy.svg"
                                alt="copy"
                                onClick={() => navigator.clipboard.writeText(props?.data.id)}
                            />
                        </Tooltip>
                    )}
                </div>
                
                <div className="form-addTicket-input" data-cy="render-field-menu-tag">
                    <div className="input-item-list"  style={isLoadingInput ? { position: 'relative'} : undefined} >
                        {isLoadingInput && (
                            <div className="loading-overlay">
                                <CircularProgress  color="primary" size={14}/>
                            </div>
                        )}
                        

                   
                        {(enableShowMore ||
                            props.data.structure.optionType ===
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT) &&
                            props.data.structure.isMultiple && props?.data?.structure?.UI !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <div className={`${(props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false ) ? 'class_disabled autoComplete-disable' : ''}`}>
                                <Autocomplete
                                    PopperComponent={PopperComponentMemo}
                                    multiple
                                    filterSelectedOptions
                                    sx={{
                                        maxHeight: 10
                                    }}
                                    options={tagList}
                                    getOptionLabel={option => option.title || ''}
                                    disableCloseOnSelect
                                    getOptionSelected={(option, selectedValue) =>
                                        option.title === selectedValue.title &&
                                        option.value === selectedValue.value
                                    }
                                    value={tagValue}
                                    disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                                    onChange={(e, newValue) => {
                                        setFirstRender(false)
                                        onClickHandler({ type: 'select', value: newValue });
                                        if (props?.setIsEdited) {
                                            props?.setIsEdited(true);
                                            if(!props?.listFieldEdited?.includes(props?.name)){
                                                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                                            }
                                            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
                                        }
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            className="form-control form-control--wrapSelect form-control--hg40"
                                            error={validateError?.isError}
                                        />
                                    )}
                                    renderOption={option => (
                                        <Tooltip title={option.title}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {option.title}
                                            </span>
                                        </Tooltip>
                                    )}
                                 
                                    ListboxProps={{
                                        style: { maxHeight: 200, overflow: "auto" }, // Ensure scrolling
                                      }}
                                />
                                </div>
                            )}
                        {(enableShowMore ||
                            props.data.structure.optionType ===
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT) &&
                            !props.data.structure.isMultiple && props?.data?.structure?.UI  !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <div className={`${(props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false ) ? 'class_disabled autoComplete-disable' : ''}`}>
                                <Autocomplete
                                    PopperComponent={PopperComponentMemo}
                                    options={tagList}
                                    sx={{
                                        maxHeight: 10
                                    }}
                                    getOptionLabel={option => option.title || ''}
                                    value={{ ...tagValue[0] }}
                                    getOptionSelected={(option, selectedValue) => {
                                        return (
                                            option.title === selectedValue.title &&
                                            option.value === selectedValue.value
                                        );
                                    }}
                                    disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                                    onChange={(e, newValue) => {
                                        onClickHandler({ type: 'select', value: [newValue] });
                                        if (props?.setIsEdited) {
                                            props?.setIsEdited(true);
                                            if(!props?.listFieldEdited?.includes(props?.name)){
                                                props?.setListFieldEdited([...props.listFieldEdited,...resetRelatedField, props?.name])
                                            }
                                            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
                                        }
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            className="form-control form-control--wrapSelect form-control--hg40"
                                            error={validateError?.isError}
                                        />
                                    )}
                                    renderOption={option => (
                                        <Tooltip title={option.title}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {option.title}
                                            </span>
                                        </Tooltip>
                                    )}
                                    ListboxProps={{
                                        style: { maxHeight: 200, overflow: "auto" }, // Ensure scrolling
                                      }}
                                />
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            props.data.structure.isMultiple && props?.data?.structure?.UI  !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                            <div className="col-flex" style={{ flexDirection: props?.isMaximizedPanel ? 'inherit' : 'column' }}>
                                    {tagList.slice(0, numOfRecordDisplay).map((item, i) => {
                                        return <div className="col-checkbox">
                                            <FormControlLabel
                                                className="tag-item custom-checkbox"
                                                control={
                                                    <Checkbox
                                                        onChange={e =>
                                                            {setFirstRender(false)
                                                            onClickHandler({
                                                                type: 'checkBox',
                                                                value: e
                                                            })}
                                                        }
                                                        value={item.value}
                                                        disabled={
                                                            props.data.structure
                                                                .publicForCustomer == 2 ||
                                                            item.isDeleted ||
                                                            !Utils.isEmptyString(
                                                                props.detailTicket?.deletedAt
                                                            ) || props.hasEditFieldPermissions === false 
                                                        }
                                                        icon={
                                                            <UnCheckIconWhite
                                                                isDiabled={
                                                                    props.data.structure
                                                                        .publicForCustomer ===
                                                                        Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
                                                                    item.isDeleted ||
                                                                    !Utils.isEmptyString(
                                                                        props.detailTicket
                                                                            ?.deletedAt
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        checkedIcon={<CheckedIcon />}
                                                        checked={isCheckedItem(item.value)}
                                                    />
                                                }
                                                label={
                                                    <OverFlowTooltipWithTabsMui 
                                                        value={item.title} 
                                                    />
                                                }
                                                data-cy="render-field-tag-checkbox"
                                            />
                                        </div>
                                    })}{' '}
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            !props.data.structure.isMultiple &&
                            (props.data.structure.settingSelectItem !==
                                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL ||
                                !props.data.structure.isAutoFill) && props?.data?.structure?.UI  !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <RadioGroup
                                    row
                                    aria-label=""
                                    name="radio-buttons-group"
                                    control={props.control}
                                    onChange={e => {
                                        setFirstRender(false)
                                       }
                                    }
                                    onClick={e=> {
                                        onClickHandler({ type: 'radio', value: e })
                                    }}
                                >
                                    {tagList.slice(0, numOfRecordDisplay).map((item, i) => (
                                        <FormControlLabel
                                            value={item.value}
                                            className="tag-item custom-radio"
                                            control={
                                                <Radio
                                                    disabled={
                                                        props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false 
                                                    }
                                                    checked={
                                                        i === getDefaultChecked() ? true : false
                                                    }
                                                />
                                            }
                                            label={
                                                <OverFlowTooltipWithTabsMui 
                                                    value={item.title} 
                                                />
                                            }
                                        />
                                    ))}
                                </RadioGroup>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            !props.data.structure.isMultiple &&
                            props.data.structure.isAutoFill &&
                            props.data.structure.settingSelectItem ===
                                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL && props?.data?.structure?.UI !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <RadioGroup
                                    row
                                    aria-label=""
                                    name="radio-buttons-group"
                                    onChange={e => {
                                        setFirstRender(false)
                                        onClickHandler({ type: 'radio', value: e })}
                                    }
                                    onClick={e=>{
                                        onClickHandler({ type: 'radio', value: e }) 
                                    }}
                                >
                                    {tagList.slice(0, numOfRecordDisplay).map((item, i) => (
                                        <FormControlLabel
                                            value={item.value}
                                            className="tag-item custom-radio"
                                            control={
                                                <Radio
                                                    disabled={
                                                        props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false 
                                                    }
                                                    checked={item.value === tagValue[0]?.value}
                                                />
                                            }
                                            label={
                                                <OverFlowTooltipWithTabsMui 
                                                    value={item.title} 
                                                />
                                            }
                                        />
                                    ))}
                                </RadioGroup>
                            )}
                        {
                           ( !enableShowMore && props?.data?.structure?.UI === Constant.FIELD_UI.TEXT_WITH_CHIP) &&
                            <>
                                <div className='searchOptionBody'>
                                    <Autocomplete
                                        className={`search-option-tag-content with-chip-auto mt-2 ${isDisableField() ? 'class_disabled autoComplete-disable' : ''}`}
                                        PopperComponent={({ style, ...props3 }) => (
                                        <Popper
                                            {...props3}
                                            style={{ ...style }} // width is passed in 'style' prop
                                            className="selectDrop"
                                        />
                                        )}
                                        multiple
                                        disableCloseOnSelect
                                        filterSelectedOptions={true}
                                        ListboxProps={{ style: { maxHeight: 350, overflow: 'auto' } }}
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        filterOptions={filterSuggestionInputChip}
                                        getOptionLabel={option => `${option?.title}`}
                                        getOptionSelected={(option, selectedValue) => {
                                            return (
                                                option?.title === selectedValue?.title &&
                                                option?.value === selectedValue?.value
                                            );
                                        }}
                                        options={_.filter(tagList, (tag, idx)=> {
                                            return tag?.isShow
                                        })}
                                        value={tagValue}
                                        onChange={(e, newValue) =>{
                                            onClickHandler({ type: 'select', value: newValue })
                                            if (props?.setIsEdited) {
                                                props?.setIsEdited(true);
                                                if(!props?.listFieldEdited?.includes(props?.name)){
                                                    props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                                                }
                                                if(props?.setOnChangeEdit){
                                                    props?.setOnChangeEdit(!props.onChangeEdit)
                                                }
                                            }
                                        } 
                                    }
                                        disabled={isDisableField()}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                error={validateError?.isError}
                                                variant="outlined"
                                                className="form-control form-control--wrapSelect form-control--hg40"
                                                onKeyDown={event => {
                                                    if (event.key === 'Backspace') event.stopPropagation();
                                                }}
                                            />
                                        )}
                                    />
                              </div>
                            </>
                        }
                        {validateError?.isError && Utils.isEmptyString(getError(props.errorlist, props.name)) && (
                            <>
                                <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                    {validateError.message}
                                </p>
                            </>
                        )}
                        {getError(props.errorlist, props.name) &&
                            <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                {getError(props.errorlist, props.name)}
                            </p>
                        }

                        {showAddItemInput &&
                            props.data.structure.publicForCustomer == 3 &&
                            (enableShowMore ||
                                props.data.structure.optionType ===
                                    Constant.TAG_FIELD_OPTION_TYPE.SELECT) && (
                                <div className="form-addItem-input">
                                    <TextField
                                        {...errorsAddItem}
                                        className="form-control addItem-text-input form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        onChange={onChangeAddItem}
                                        onKeyPress={handleOnKeyPressAddItem}
                                        error={!Utils.isEmptyString(errorsAddItem)}
                                    ></TextField>
                                    {!Utils.isEmptyString(errorsAddItem) && (
                                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                            {errorsAddItem}
                                        </p>
                                    )}
                                </div>
                            )}
                    </div>
                    <div className="tag-field-control">
                        {showAddItemInput &&
                            props.data.structure.publicForCustomer == 3 &&
                            !(
                                enableShowMore ||
                                props.data.structure.optionType ===
                                    Constant.TAG_FIELD_OPTION_TYPE.SELECT
                            ) && (
                                <div className="form-addItem-input">
                                    <TextField
                                        {...errorsAddItem}
                                        className="form-control addItem-text-input form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        onChange={onChangeAddItem}
                                        onKeyPress={handleOnKeyPressAddItem}
                                        error={!Utils.isEmptyString(errorsAddItem)}
                                    ></TextField>
                                    {!Utils.isEmptyString(errorsAddItem) && (
                                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                            {errorsAddItem}
                                        </p>
                                    )}
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.publicForCustomer !== 2 &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT && tagList.length > numOfRecordDisplay &&(
                                <Box
                                    className={
                                        Utils.isEmptyString(props.detailTicket?.deletedAt)
                                            ? 'show-more-button link-file-name'
                                            : 'disable-show-more-button'
                                    }
                                    onClick={e =>
                                        Utils.isEmptyString(props.detailTicket?.deletedAt)
                                            ? enableShowMoreTagList()
                                            : e.preventDefault()
                                    }
                                    data-cy="render-field-tag-seemore"
                                >
                                    もっと見る
                                </Box>
                            )}
                    </div>
                </div>
            </div>
        </>
    );
}
